import QRCode from "qrcode";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import {
  Alert,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Media,
  Nav,
  Col,
  Row,
  Navbar,
  UncontrolledDropdown,
} from "reactstrap";
import { CloseAlert, logout } from "store/actions/authActions";
import NextLogo from "assets/img/Mpink.png";
import Notifications from "./Notifications";
import SidebarToggleIcon from "./SidebarToggleIcon";

const AdminNavbar = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { hide, setHide } = props;
  const { user, userPermissions } = useSelector((state) => state.auth);
  const notificationAccess =
    (user?.type === "restaurant" && user?.subScriptionStatus === "subscribe") ||
    userPermissions?.notifications?.active;
  const { restaurantsDetail } = useSelector((state) => state.restaurant);
  const [visible, setVisible] = useState(true);
  const onDismiss = () => setVisible(false);

  const adminColor =
    user?.adminColor || restaurantsDetail?.adminColor || "#d70365";

  const MoveToStoreTiming = () => {
    dispatch(CloseAlert(user?.restaurantID, onDismiss));
    history.push("/admin/settings/venue-setting-menu/store-timings");
  };

  const generateQRCode = () => {
    const url = `https://nexteats-admin.web.app/restaurant/${user?.restaurantID}`;
    QRCode.toDataURL(
      url,
      {
        width: 800,
        margin: 2,
        color: {
          dark: "#335383FF",
          light: "#EEEEEEFF",
        },
      },
      (err, url) => {
        if (err) return console.error(err);
        const link = document.createElement("a");
        link.download = `qrcode_${user?.restaurantID}.png`;
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    );
  };

  return (
    <>
      <Navbar
        className={`navbar-dark ${hide ? "navbar-top-hide" : "navbar-top"}`}
        expand="md"
        id="navbar-main"
      >
        <Col>
          <Row>
            <Container fluid className="justify-content-end">
              <div className="me-auto d-flex cursor-pointer justify-content-center align-items-center mx-3 navbar__items">
                <div id="google_translate_element" className="mt-3"></div>
                <div
                  className={hide ? "sidebar-icon-2" : "sidebar-icon "}
                  onClick={(e) => {
                    e.preventDefault();
                    setHide((prevState) => !prevState);
                  }}
                >
                  <SidebarToggleIcon
                    hide={hide}
                    adminColor={adminColor}
                  />
                </div>
              </div>
              {user?.type !== "admin" && props.isSubscribed && (
                <Link onClick={generateQRCode}>Download QR Code </Link>
              )}
              <Nav className="align-items-center d-none d-md-flex" navbar>
                {notificationAccess && <Notifications />}
                <UncontrolledDropdown nav>
                  <DropdownToggle className="navbar-top__profile-toggler" nav>
                    <Media className="align-items-center">
                      <img
                        className="avatar avatar-sm rounded"
                        alt="logo"
                        src={user?.restaurantLogo || NextLogo}
                      />
                      <Media className="d-none d-lg-flex ml-2 flex-column">
                        <span className="mb-0 text-sm text-dark font-weight-bold">
                          {user?.name}
                        </span>
                      </Media>
                    </Media>
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu-arrow mt-2" right>
                    {user?.type === "restaurant" && (
                      <DropdownItem
                        onClick={() => history.push("/admin/settings/account")}
                      >
                        <i className="ni ni-single-02" />
                        <span>Restaurant Profile</span>
                      </DropdownItem>
                    )}

                    <DropdownItem onClick={() => dispatch(logout())}>
                      <i className="ni ni-user-run" />
                      <span>Logout</span>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            </Container>
          </Row>
        </Col>
        {user?.firsttimelogin && user?.subScriptionStatus === "subscribe" && (
          <Alert
            color="secondary"
            isOpen={visible}
            toggle={onDismiss}
            className="d-flex justify-content-center align-items-center position-fixed right-4 top-7 border shadow-lg"
          >
            <i className="fas fa-2x fa-triangle-exclamation text-warning mr-4" />
            <div className="d-flex align-items-center">
              <div className="d-flex flex-column">
                Reminder! Don't forget to Add Restaurant Timings
                <Link className="underline" onClick={MoveToStoreTiming}>
                  <u>Adjust store timings here</u>
                </Link>
              </div>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={() =>
                  dispatch(CloseAlert(user?.restaurantID, onDismiss))
                }
              >
                <span aria-hidden="true" style={{ color: "red" }}>
                  &times;
                </span>
              </button>
            </div>
          </Alert>
        )}
      </Navbar>
    </>
  );
};

export default AdminNavbar;
